import { TmBaseError } from '@/core/error/tmBaseError'

export class TmResolverError extends TmBaseError {
  public name = 'TmResolverError'
}
